import {
  SiSpotify,
  SiApple,
  SiSoundcloud,
  SiYoutubemusic,
  SiTidal,
  SiAmazonmusic,
  SiBandcamp,
  SiFacebook,
  SiX,
  SiInstagram,
  SiYoutube,
  SiTiktok,
  SiSnapchat,
} from "react-icons/si";

const baseUrlMap = {
  spotify: "https://open.spotify.com/artist/",
  apple_music: "https://music.apple.com/artist/",
  soundcloud: "https://soundcloud.com/",
  youtube_music: "https://music.youtube.com/channel/",
  tidal: "https://tidal.com/browse/artist/",
  amazon_music: "https://music.amazon.com/artists/",
  bandcamp: "https://", // Needs special handling or assume full URL
  facebook: "https://facebook.com/",
  x: "https://x.com/",
  instagram: "https://instagram.com/",
  youtube: "https://youtube.com/",
  tiktok: "https://tiktok.com/@",
  snapchat: "https://snapchat.com/add/",
};

const iconMap = {
  spotify: SiSpotify,
  apple_music: SiApple,
  soundcloud: SiSoundcloud,
  youtube_music: SiYoutubemusic,
  tidal: SiTidal,
  amazon_music: SiAmazonmusic,
  bandcamp: SiBandcamp,
  facebook: SiFacebook,
  x: SiX,
  instagram: SiInstagram,
  youtube: SiYoutube,
  tiktok: SiTiktok,
  snapchat: SiSnapchat,
};

const hasHttpProtocol = (value) =>
  value.startsWith("http://") || value.startsWith("https://");

const hasValidBandcampHost = (value) => {
  const candidate = hasHttpProtocol(value) ? value : `https://${value}`;

  try {
    const url = new URL(candidate);
    return (
      url.hostname === "bandcamp.com" || url.hostname.endsWith(".bandcamp.com")
    );
  } catch {
    return false;
  }
};

const getFullUrl = (key, value) => {
  if (typeof value !== "string") return "";

  const trimmedValue = value.trim();
  if (!trimmedValue) return "";
  if (hasHttpProtocol(trimmedValue)) {
    return trimmedValue;
  }

  if (key === "bandcamp") {
    if (hasValidBandcampHost(trimmedValue)) {
      return hasHttpProtocol(trimmedValue)
        ? trimmedValue
        : `https://${trimmedValue}`;
    }
    return `https://${trimmedValue}.bandcamp.com`;
  }

  const baseUrl = baseUrlMap[key] || "";
  return `${baseUrl}${trimmedValue}`;
};

const IconsList = ({ data }) => {
  const iconData = data && typeof data === "object" ? data : {};

  return (
    <>
      <div className="flex gap-4">
        {Object.keys(iconData).map((key, index) => {
          const Icon = iconMap[key];
          const value = iconData[key];

          if (Icon && value) {
            const href = getFullUrl(key, value);
            if (!href) return null;
            return (
              <div key={index} className="m-2">
                <a href={href} target="_blank" rel="noopener noreferrer">
                  {Icon && (
                    <Icon size={32} className="text-white hover:text-primary" />
                  )}
                </a>
              </div>
            );
          }
          return null; // No value for the key
        })}
      </div>
    </>
  );
};

export default IconsList;
